import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const stepColors = ['bg-cyan-500 text-slate-950', 'bg-amber-500 text-slate-950', 'bg-emerald-500 text-slate-950'];

const stepCodes: Record<string, ReactNode> = {
  'howItWorks.step2': (
    <code className="text-slate-300">
      <span className="text-slate-500">$</span> quicktl init
      <br />
      <span className="text-emerald-400">✔</span> Select a project{' '}
      <span className="text-cyan-400">my-app</span>{' '}
      <span className="text-slate-500">(en → fr, es, de)</span>
      <br />
      <span className="text-emerald-400">✔</span> Source locale file{' '}
      <span className="text-slate-500">locales/en.json</span>
      <br />
      <span className="text-emerald-400">✔</span> Target path pattern{' '}
      <span className="text-slate-500">locales/&#123;locale&#125;.json</span>
      <br />
      <span className="text-emerald-400">✓</span> Created .quicktl.json
    </code>
  ),
  'howItWorks.step3': (
    <code className="text-slate-300">
      <span className="text-slate-500">$</span> quicktl translate
      <br />
      <span className="text-emerald-400">✔</span> Pushed 142 keys to main
      <br />
      <span className="text-emerald-400">✔</span> Translated 142 strings
      <br />
      <span className="text-emerald-400">✔</span> Downloaded 3 locale(s)
      <br />
      {'  '}fr → <span className="text-slate-500">locales/fr.json</span>
      <br />
      {'  '}es → <span className="text-slate-500">locales/es.json</span>
      <br />
      {'  '}de → <span className="text-slate-500">locales/de.json</span>
    </code>
  ),
};

const stepKeys = ['howItWorks.step1', 'howItWorks.step2', 'howItWorks.step3'];

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section id="how-it-works" className="border-t border-slate-800/50">
      <div className="mx-auto max-w-6xl px-6 py-20 md:py-28">
        <div className="text-center">
          <h2 className="font-display text-3xl font-bold tracking-tight md:text-4xl">
            {t('howItWorks.heading')}
          </h2>
          <p className="mt-4 text-slate-400">
            {t('howItWorks.subheading')}
          </p>
        </div>

        <div className="mt-14 grid gap-8 md:grid-cols-3">
          {stepKeys.map((key, i) => (
            <div key={key} className="relative">
              <div className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold ${stepColors[i]}`}>
                {t(`${key}.number`)}
              </div>
              <h3 className="mt-4 font-display text-lg font-semibold">{t(`${key}.title`)}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">
                {t(`${key}.description`)}
              </p>
              {stepCodes[key] && (
                <div dir="ltr" className="mt-4 rounded-xl border border-slate-800/80 bg-slate-900/80 px-4 py-3 font-mono text-xs">
                  {stepCodes[key]}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
